// src/components/ChoreTiles.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, onSnapshot, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import Modal from './Modal'; // <-- NEW: Import the Modal component

const ChoreTiles = () => {
  const [users, setUsers] = useState([]);
  const [chores, setChores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedChore, setSelectedChore] = useState(null); // <-- NEW: State for the pop-up

  // ... (useEffect for fetching users is unchanged) ...
  useEffect(() => {
    const q = query(collection(db, 'users'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const usersData = [];
      querySnapshot.forEach((doc) => {
        usersData.push({ id: doc.id, ...doc.data() });
      });
      setUsers(usersData);
    });
    return () => unsubscribe();
  }, []);

  // ... (useEffect for fetching chores is unchanged) ...
  useEffect(() => {
    const q = query(collection(db, 'chores'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const choresData = [];
      querySnapshot.forEach((doc) => {
        choresData.push({ id: doc.id, ...doc.data() });
      });
      setChores(choresData);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // ... (toggleComplete and deleteChore functions are unchanged) ...
  const toggleComplete = async (chore) => {
    await updateDoc(doc(db, 'chores', chore.id), {
      isComplete: !chore.isComplete,
    });
  };

  const deleteChore = async (id) => {
    await deleteDoc(doc(db, 'chores', id));
  };

  // NEW: Handlers for opening/closing the description modal
  const handleShowDescription = (chore) => {
    setSelectedChore(chore);
  };

  const handleCloseDescription = () => {
    setSelectedChore(null);
  };

  if (loading) {
    return <div className="loading">Loading Chores...</div>;
  }

  return (
    <> {/* <-- Wrap in fragment */}
      <div className="chore-tiles-container">
        {users.map((user) => (
          <div key={user.id} className="user-chore-tile">
            <h4>{user.nickname || user.email}</h4>
            <div className="chores-for-person">
              {chores
                .filter(chore => chore.assignedTo === user.id)
                .map(chore => (
                  <div key={chore.id} className={`chore-item ${chore.isComplete ? 'completed' : ''}`}>
                    
                    {/* NEW: Wrapper for task and info icon */}
                    <div className="chore-task-with-info">
                      <span className="chore-task">{chore.task}</span>
                      {/* NEW: Conditionally render info icon */}
                      {chore.description && (
                        <button className="info-btn" onClick={() => handleShowDescription(chore)}>
                          ℹ️
                        </button>
                      )}
                    </div>

                    <div className="chore-actions">
                      <button onClick={() => toggleComplete(chore)}>
                        {chore.isComplete ? 'Undo' : '✓'}
                      </button>
                      <button className="delete-btn" onClick={() => deleteChore(chore.id)}>
                        X
                      </button>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        ))}
      </div>

      {/* NEW: Modal for displaying the description */}
      {selectedChore && (
        <Modal 
          isOpen={true} 
          onClose={handleCloseDescription} 
          title={selectedChore.task}
        >
          <p className="chore-description-text">{selectedChore.description}</p>
        </Modal>
      )}
    </>
  );
};

export default ChoreTiles;